/** Ajustes do CRM (27/10, F4) e lote crm6 (item 14): as tags dos modelos de e-mail e o preenchimento delas. */

/** As tags do RD nos modelos de e-mail e o que entra no lugar de cada uma. */
export const TAGS_EMAIL = ['contato-nome', 'contato-cargo', 'deal-nome', 'deal-empresa', 'usuario-nome', 'tratamento', 'o/a'] as const;

/** Troca as tags do modelo pelos dados da negociação (vazio quando não há o dado). `escapar` para o HTML do editor. */
export function preencherTags(texto: string, v: Partial<Record<(typeof TAGS_EMAIL)[number], string | null>>, escapar = false) {
  const esc = (x: string) => (escapar ? x.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]!) : x);
  // crm6 item 14: `{{tratamento}}` vazio (contato neutro) leva junto o espaço seguinte ("Olá, {{tratamento}} Ana" → "Olá, Ana").
  return texto.replace(/\{\{\s*([a-z/-]+)\s*\}\}( ?)/g, (todo, tag: string, espaco: string) => {
    if (!TAGS_EMAIL.includes(tag as never)) return todo;
    const valor = v[tag as (typeof TAGS_EMAIL)[number]] ?? '';
    return tag === 'tratamento' && !valor ? '' : `${esc(valor)}${espaco}`;
  });
}
